module.exports = __webpack_public_path__ + "img/carouselBg2.2c3ce247.png";